<template>
  <!-- <a-drawer :maskClosable="false"width="65%" :label-col="4" :wrapper-col="14" :visible="open" @close="onClose" :destroyOnClose="true">
    <a-divider orientation="left">
      <b>{{ formTitle }}</b>
    </a-divider> -->

  <div>
    <div><a-button type="link" @click="hanleBack"> 返回 </a-button>> <span style="margin-left: 10px">详情</span></div>
    <div class="card-container">
      <div>
        <div>1212</div>
      </div>
      <a-tabs @change="callback" v-model="active" type="card" size="large">
        <a-tab-pane :key="1" tab="详细信息" class="plan_con">
          <!-- v-if="form.status == 5" -->
          <!-- <div>
          <a-button
            type="primary"
            style="width: 150px; height: 50px; margin-bottom: 30px; font-size: 28px"
            @click="$refs.Examine.init(form, 1)"
          >
            审核
          </a-button>
        </div>
        <div>
          <a-button
            type="primary"
            @click="handlePdf"
            style="width: 150px; height: 50px; margin-bottom: 30px; font-size: 28px"
          >
            生成pdf
          </a-button>
        </div> -->
          <div id="pdf">
            <a-descriptions :column="4" title="业主信息" class="full-width-descriptions">
              <a-descriptions-item label="业主姓名"> {{ form.ownerName }} </a-descriptions-item>
              <a-descriptions-item label="业主电话"> {{ form.ownerPhone }} </a-descriptions-item>
              <a-descriptions-item label="小区名称"> {{ form.minAreaName }} </a-descriptions-item>
              <a-descriptions-item label="预约姓名" v-if="form.orderType">
                {{ form.reservationName }}
              </a-descriptions-item>
              <a-descriptions-item label="预约手机号" v-if="form.orderType">
                {{ form.reservationPhone }}
              </a-descriptions-item>
              <a-descriptions-item label="业主地址"> {{ form.ownerAddress }} </a-descriptions-item>
            </a-descriptions>
            <a-descriptions
              :column="4"
              title="评价信息"
              class="full-width-descriptions"
              v-if="evaluateInfoResult && from.evaluateState"
            >
              <a-descriptions-item label="对企业品牌的建议及意见">
                {{ evaluateInfoResult.suggestionsAndComments }}
              </a-descriptions-item>
              <a-descriptions-item label="低分预警">
                {{ evaluateInfoResult.alertStatus ? '预警' : '正常' }}
              </a-descriptions-item>
              <a-descriptions-item label="评价时间">
                {{ parseTime(evaluateInfoResult.createTime) }}
              </a-descriptions-item>
              <a-descriptions-item label="评价内容"> {{ evaluateInfoResult.evaluationContent }} </a-descriptions-item>
              <a-descriptions-item label="处理情况">
                {{ evaluateInfoResult.handlingSituation ? '已处理' : '未处理' }}
              </a-descriptions-item>
              <a-descriptions-item label="处理说明"> {{ evaluateInfoResult.handlingVal }} </a-descriptions-item>

              <a-descriptions-item label="备注"> {{ evaluateInfoResult.remark }} </a-descriptions-item>
            </a-descriptions>
            <a-descriptions :column="4" title="试压信息" class="full-width-descriptions">
              <a-descriptions-item label="派单编号"> {{ form.ownerName }} </a-descriptions-item>
              <a-descriptions-item label="测试结果"> {{ form.ownerPhone }} </a-descriptions-item>
              <a-descriptions-item label="派单状态"> {{ form.minAreaName }} </a-descriptions-item>
              <!-- <a-descriptions-item label="设备名称"> {{ form.ownerAddress }} </a-descriptions-item> -->
              <a-descriptions-item label="项目经理"> {{ form.proBane }} </a-descriptions-item>
              <a-descriptions-item label="经理电话"> {{ form.proPhone }} </a-descriptions-item>
              <a-descriptions-item label="企业品牌"> {{ form.decorationSituation }} </a-descriptions-item>
              <template v-if="reportInfoResult">
                <a-descriptions-item label="装修情况"> {{ reportInfoResult.decorationSituation }} </a-descriptions-item>
                <a-descriptions-item label="购买渠道"> {{ reportInfoResult.purchaseChannels }} </a-descriptions-item>
                <a-descriptions-item label="房屋类型"> {{ reportInfoResult.houseType }} </a-descriptions-item>
                <a-descriptions-item label="施工属性">
                  {{ reportInfoResult.constructionAttributes }}
                </a-descriptions-item>
                <a-descriptions-item label="施工主体"> {{ reportInfoResult.constructionSubject }} </a-descriptions-item>
                <a-descriptions-item label="服务类型"> {{ reportInfoResult.houseLayout }} </a-descriptions-item>
                <a-descriptions-item label="房屋户型"> {{ reportInfoResult.houseLayout }} </a-descriptions-item>
                <a-descriptions-item label="全套产品">
                  {{ reportInfoResult.completeProducts ? '是' : '否' }}
                </a-descriptions-item>
                <a-descriptions-item label="出水口数">
                  {{ reportInfoResult.deliveryPortNum }}
                </a-descriptions-item>
                <a-descriptions-item label="施工空间"> {{ reportInfoResult.spatialData }} </a-descriptions-item>
                <a-descriptions-item label="房屋面积"> {{ reportInfoResult.housingArea }} </a-descriptions-item>
                <a-descriptions-item label="厨房数量"> {{ reportInfoResult.kitchenCount }} </a-descriptions-item>

                <a-descriptions-item label="开始时间"> {{ reportInfoResult.startTime }} </a-descriptions-item>
                <a-descriptions-item label="结束时间"> {{ reportInfoResult.endTime }} </a-descriptions-item>
                <a-descriptions-item label="试压用时"> {{ reportInfoResult.exertTime }} </a-descriptions-item>
                <a-descriptions-item label="起始压力"> {{ reportInfoResult.initialPressure }} </a-descriptions-item>
                <a-descriptions-item label="结束压力"> {{ reportInfoResult.endPressure }} </a-descriptions-item>
                <a-descriptions-item label="过程压降"> {{ reportInfoResult.processPressureDrop }} </a-descriptions-item>
                <a-descriptions-item label="业主评价">
                  {{
                    reportInfoResult.ownerEvaluate == 0
                      ? '未评价'
                      : reportInfoResult.ownerEvaluate == 1
                      ? '非常满意'
                      : reportInfoResult.ownerEvaluate == 2
                      ? '满意'
                      : '不满意'
                  }}
                </a-descriptions-item>
                <a-descriptions-item label="业主在场">
                  {{ reportInfoResult.ownersPresent ? '在' : '否' }}
                </a-descriptions-item>
                <a-descriptions-item label="管道长度	"> {{ reportInfoResult.pipeLength }} </a-descriptions-item>
                <a-descriptions-item label="前置过滤器数		"> {{ reportInfoResult.preFilterCount }} </a-descriptions-item>
                <a-descriptions-item label="预设压力	"> {{ reportInfoResult.presetPressure }} </a-descriptions-item>
                <a-descriptions-item label="预设时间	"> {{ reportInfoResult.presetTime }} 分钟</a-descriptions-item>
                <a-descriptions-item label="判断结果	">
                  {{ reportInfoResult.pressureResult ? '不合格' : '合格' }}
                </a-descriptions-item>
                <a-descriptions-item label="	系统类型	"> {{ reportInfoResult.pipeLength }} </a-descriptions-item>
                <a-descriptions-item label="管道长度	"> {{ reportInfoResult.systemTypeName }} </a-descriptions-item>
                <a-descriptions-item label="卫生间数	"> {{ reportInfoResult.toiletCount }} </a-descriptions-item>
                <a-descriptions-item label="阀门企业品牌	"> {{ reportInfoResult.valveBrand }} </a-descriptions-item>
                <a-descriptions-item label="阀门数量		"> {{ reportInfoResult.valveCount }} </a-descriptions-item>
                <a-descriptions-item label="分水器数		"> {{ reportInfoResult.waterCount }} </a-descriptions-item>
                <a-descriptions-item label="质保承诺"> {{ reportInfoResult.warrantyCommitment }} </a-descriptions-item>
              </template>
              <a-descriptions-item label="水工名称"> {{ form.waterName }} </a-descriptions-item>
              <a-descriptions-item label="水工电话"> {{ form.waterPhone }} </a-descriptions-item>
              <a-descriptions-item label="试压状态"> {{ form.status | orderStates }} </a-descriptions-item>
              <a-descriptions-item label="提交时间"> {{ parseTime(form.subTime) }} </a-descriptions-item>
              <a-descriptions-item label="审核时间"> {{ parseTime(form.acceptTime) }} </a-descriptions-item>
              <a-descriptions-item label="审核状态">
                {{
                  form.acceptStatus == 0
                    ? '无需审核'
                    : form.待审核 == 1
                    ? '待审核'
                    : form.acceptStatus == 2
                    ? '审核打回'
                    : '通过'
                }}
              </a-descriptions-item>
            </a-descriptions>
            <a-descriptions :column="4" title="VR全景" class="full-width-descriptions">
              <div>
                <a-button type="primary" v-if="form.vrState" @click="handleDown(form.vrUrl)">水电管路图查询 </a-button>
                <a-button type="primary" v-else @click="$refs.Examine.init(form, 10)">设置VR </a-button>
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="试压状态图" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="业主门牌号" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="走廊过道照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="客厅照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="客厅照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="主卧照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="次卧照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="厨房照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="主卫生间照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="次卫生间" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="阳台照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="温馨提示照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions :column="4" title="其他照片" class="full-width-descriptions">
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
            <a-descriptions
              :column="4"
              title="品质凭证照片(管路验收卡、质保书中的管路验收卡)"
              class="full-width-descriptions"
            >
              <div v-viewer>
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
                <img src="~@/assets/images/profile.jpg" alt="" />
              </div>
            </a-descriptions>
          </div>
        </a-tab-pane>
        <a-tab-pane :key="2" tab="试压流程" force-render>
          <template>
            <a-timeline>
              <a-timeline-item
                :color="item.state == 0 ? 'green' : 'red'"
                v-for="(item, index) in recordList"
                :key="index"
              >
                {{ item.descriptionVal }}
              </a-timeline-item>
            </a-timeline>
          </template>
        </a-tab-pane>

        <!-- <a-tab-pane :key="3" tab="Tab 3"> Content of Tab Pane 3 </a-tab-pane> -->
      </a-tabs>
    </div>
    <Examine ref="Examine" @ok="handleOk"></Examine>
  </div>
  <!-- </a-drawer> -->
</template>
  <script>
import { getObj, addObj, putObj, tenantUser, addObj1, acceptance, recordPage } from '@/api/pressure/dispatch'
import mapAdd from '@/components/AMap/index'
import moment from 'moment'
import Examine from './examine'
import html2canvas from 'html2canvas'
import JsPDF from 'jspdf'
export default {
  name: 'CreateForm',
  props: {
    statusOptions: {
      type: Array,
      required: false,
    },
  },
  components: { mapAdd, Examine },
  data() {
    const reg = /^1(3|4|5|6|7|8|9)\d{9}$/
    const validatePhone = (rule, value, callback) => {
      if (value === '') {
        callback(new Error('请输入联系电话'))
      } else if (!reg.test(value)) {
        callback(new Error('请输入正确的联系电话'))
      } else {
        callback()
      }
    }
    return {
      submitLoading: false,
      data: [],
      reportInfoResult: {},
      formTitle: '',
      inputValue: '',
      inputValues: '',
      recordList: [],
      // 表单参数
      form: {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
      },
      isShow: false,
      open: false,
      inspector: [],
      active: 1,
      evaluateInfoResult: {},
      rules: {
        ownerPhone: [
          { required: true, message: '请输入联系电话', trigger: 'blur' },
          { validator: validatePhone, trigger: 'change' },
        ],
        minAreaName: [{ required: true, message: '请输入小区名称', trigger: 'blur' }],
        ownerName: [{ required: true, message: '请输入业主姓名', trigger: 'blur' }],
        pressureTestUserId: [{ required: true, message: '请选择验收员', trigger: 'blur' }],
        ownerAddress: [{ required: true, message: '请输入详细地址', trigger: 'blur' }],
        reservationTime: [{ required: true, message: '请选择预约时间', trigger: 'blur' }],
        area: [{ required: true, message: '请在地图上选择位置信息', trigger: 'blur' }],
      },
      options: ['地面走管', '墙面走管', '屋顶走管'],
    }
  },
  filters: {
    orderStates(value) {
      let num
      if (value === 0) {
        num = '待确认'
      } else if (value === 1) {
        num = '待派单'
      } else if (value === 2) {
        num = '派单拒绝'
      } else if (value === 3) {
        num = '待接单'
      } else if (value === 4) {
        num = '已受理'
      } else if (value === 5) {
        num = '已提交审核'
      } else if (value === 7) {
        num = '已完成'
      } else if (value === 8) {
        num = '订单作废'
      }
      return num
    },
  },
  created() {
    console.log('statusOptions 显示隐藏', this.statusOptions)
    // this.getUserList(0)
    console.log('对对对对对对')
  },
  computed: {},
  watch: {},
  methods: {
    // 点击切换tabs
    callback(key) {
      console.log(key)
      key = Number(key)
      this.active = key
      if (key === 2) {
        recordPage({ orderId: this.form.id }).then((res) => {
          console.log(res, '顶顶顶顶')
          this.recordList = res.data.records
        })
      }
    },
    hanleBack() {
      this.$emit('back')
    },
    // 点击审核通过
    handleOk() {},
    // 查询验收和水工
    getUserList(type) {
      console.log(type, '测试数据====企业品牌啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪啪')
      tenantUser({ type: type, pageNum: 1, pageSize: 999 }).then((res) => {
        this.inspector = res.data.records
        console.log(res.data, 'res.datares.datares.data')
      })
    },
    // 下载验收报告
    handleDown(e) {
      acceptance(e.id).then((res) => {
        window.open(res.data, '_blank')
      })
      // window.open(e)
    },
    // 生成pdf
    handlePdf() {
      this.downloadPDF(document.querySelector('#pdf'), '派单报告')
    },
    downloadPDF(ele, pdfName) {
      const eleW = ele.offsetWidth // 获得该容器的宽
      const eleH = ele.offsetHeight // 获得该容器的高
      console.log(eleH, 'eleWeleW==')
      const eleOffsetTop = ele.offsetTop // 获得该容器到文档顶部的距离
      const eleOffsetLeft = ele.offsetLeft // 获得该容器到文档最左的距离
      console.log(eleOffsetLeft, 'eleOffsetLeft')
      var canvas = document.createElement('canvas')
      var abs = 0
      const win_in = document.documentElement.clientWidth || document.body.clientWidth // 获得当前可视窗口的宽度（不包含滚动条）
      const win_out = window.innerWidth // 获得当前窗口的宽度（包含滚动条）
      if (win_out > win_in) {
        // abs = (win_o - win_i)/2;    // 获得滚动条长度的一半
        abs = (win_out - win_in) / 2 // 获得滚动条宽度的一半
        // console.log(a, '新abs');
      }
      console.log(win_in, 'win_inwin_in')
      canvas.width = eleW * 2 // 将画布宽&&高放大两倍
      canvas.height = eleH * 2
      var context = canvas.getContext('2d')
      context.scale(2, 2)
      context.translate(-eleOffsetLeft - abs, -eleOffsetTop)
      // 这里默认横向没有滚动条的情况，因为offset.left(),有无滚动条的时候存在差值，因此
      // translate的时候，要把这个差值去掉
      // html2canvas(element).then( (canvas)=>{ //报错
      // html2canvas(element[0]).then( (canvas)=>{
      window.scroll(0, 1) // 这行代码也需要写！
      const node = document.getElementById('pdf')
      var imgWidth = 595.28
      const elehs = this.leg > 14 ? eleH + 80 : eleW + 80
      const scrollTop = document.documentElement.scrollTop || document.body.scrollTop // 获取滚动轴滚动的长度
      html2canvas(ele, {
        dpi: window.devicePixelRatio * 2,
        X: 0,
        useCORS: true, // 开启跨域配置
        scale: 2,
        width: elehs,
        // allowTaint: true,  //允许 canvas 污染， allowTaint参数要去掉，否则是无法通过toDataURL导出canvas数据的
        useCORS: true, // 允许canvas画布内 可以跨域请求外部链接图片, 允许跨域请求。
      }).then((canvas) => {
        var contentWidth = canvas.width
        var contentHeight = canvas.height
        // 一页pdf显示html页面生成的canvas高度;
        var pageHeight = (contentWidth / 592.28) * 841.89
        // 未生成pdf的html页面高度
        var leftHeight = contentHeight
        // 页面偏移
        // a4纸的尺寸[595.28,841.89]，html页面生成的canvas在pdf中图片的宽高
        var imgHeight = (595.28 / contentWidth) * contentHeight
        var pageData = canvas.toDataURL('image/jpeg', 1)
        // console.log(pageData, 'pageDatapageDatapageData===')
        var pdf = new JsPDF('', 'pt', 'a4')

        // 有两个高度需要区分，一个是html页面的实际高度，和生成pdf的页面高度(841.89)
        // 当内容未超过pdf一页显示的范围，无需分页
        const pdfHight = (pdf.internal.pageSize.height - imgHeight) / 2
        const pdfHights = pdf.internal.pageSize.height - imgHeight - 10
        const indexs = this.leg > 14 ? pdfHights : 10
        var position = 10
        const pdfWidths = (pdf.internal.pageSize.width - eleW) / 2
        // console.log(pdf.internal.pageSize.width, 'pdfHightpdfHightpdfHight');
        if (leftHeight < pageHeight) {
          // 在pdf.addImage(pageData, 'JPEG', 左，上，宽度，高度)设置在pdf中显示；
          pdf.addImage(pageData, 'JPEG', 10, indexs, imgWidth, imgHeight)
          // pdf.addImage(pageData, 'JPEG', 20, 40, imgWidth, imgHeight);
        } else {
          // 分页
          while (leftHeight > 0) {
            pdf.addImage(pageData, 'JPEG', 10, position, imgWidth, imgHeight)
            leftHeight -= pageHeight
            position -= 841.89
            // 避免添加空白页
            if (leftHeight > 0) {
              pdf.addPage()
            }
          }
        }
        var pdfData = pdf.output('datauristring') // 获取base64Pdf
        // console.log(pdfData, 'pdfDatapdfDatapdfData获取base64的方法===');
        setTimeout(() => {
          dataPdf({ base64Str: pdfData, userId: this.dataFrom.userId }).then((res) => {
            console.log(res.data.data, '滴滴滴滴滴滴')
            var u = navigator.userAgent
            var isAndroid = u.indexOf('Android') > -1 || u.indexOf('Adr') > -1 // android终端
            var isiOS = !!u.match(/\(i[^;]+;( U;)? CPU.+Mac OS X/) // ios终端
            if (isiOS) {
              webkit.messageHandlers.appExport.postMessage(res.data.data)
            } else {
              // webView.getSettings().setJavaScriptEnabled(true);
              window.android.postPdfAddress(res.data.data)
            }
          })
        }, 1000)
        setTimeout(() => {
          // 可动态生成
          pdf.save(pdfName)
        }, 2000)
      })
    },
    // 时间选择
    onChange(e) {
      console.log(e, '121212888')
      this.form.reservationTime = moment(e).format('YYYY-MM-DD HH:mm')
    },
    onClose() {
       const that = this
      this.$confirm({
        title: '是否确认关闭清空数据',
        onOk() {
          console.log(that.open, 'openopen')
          that.open = false
        },
        onCancel() {},
      })
    },
      onChangeProvince(e) {
      console.log(e, 'dddd点点滴')
      if (e.code) {
        this.form.province = e.value
      } else {
        this.form.province = ''
        this.form.city = ''
        this.form.area = ''
      }
    },
    // 选择市
       onChangeCity(e) {
      if (e.code) {
        this.queryParam.city = e.value
      } else {
        this.queryParam.city = ''
        this.queryParam.area = ''
      }
    },
    // 选择区
      onChangeArea(e) {
      if (e.code) {
        this.queryParam.area = e.value
      } else {
        this.queryParam.area = ''
      }
    },

    filterOption(input, option) {
      return option.componentOptions.children[0].text.toLowerCase().indexOf(input.toLowerCase()) >= 0
    },
    getInfo(e) {
      this.form.ownerAddress = e.detailedAddress
      this.form.lat = e.lat
      this.form.log = e.lng
      this.form.province = e.addressComponent.province
      this.form.city = e.addressComponent.city ? e.addressComponent.city : e.addressComponent.province
      this.form.area = e.addressComponent.district
      this.$forceUpdate()
      // console.log(e, 'ddddmm打得动');
    },
    // 取消按钮
    cancel() {
      this.onClose()
    },
    // 表单重置
    reset() {
      this.form = {
        id: undefined,
        area: undefined,
        lat: undefined,
        log: undefined,
        minAreaName: undefined,
        ownerAddress: undefined,
        ownerName: undefined,
        ownerPhone: undefined,
        pressureTestName: undefined,
        pressureTestUserId: undefined,
        pressureTestUserPhone: undefined,
        province: undefined,
        remark: undefined,
        reservationTime: undefined,
        tenantAgentId: undefined,
        tenantFirmId: undefined,
        tenantId: undefined,
        waterUserId: undefined,
      }
    },
    // 点击提交型号口径
    handleModelAdd() {
      if (this.form.modelCaliberAddParams.length === 0) {
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      } else {
        const index = this.form.modelCaliberAddParams.length - 1
        if (!this.form.modelCaliberAddParams[index].name) return this.$message.error('请输入口径名称')
        if (!this.form.modelCaliberAddParams[index].sort) return this.$message.error('请输入口径排序')
        this.form.modelCaliberAddParams.push({ name: '', sort: '' })
      }
    },
    handleModelDel(index) {
      this.form.modelCaliberAddParams.splice(index, 1)
    },
    /** 新增按钮操作 */
    handleAdd() {
      this.reset()
      this.open = true
      this.formTitle = '添加预约订单'
    },
    /** 修改按钮操作 */
    init(row, ids) {
      console.log(1111)
      //   this.reset()
      const postId = row ? row.id : ids
      getObj(postId).then((response) => {
        if (response.data.installationMethod) {
          const arr = response.data.installationMethod.split(',')
          response.data.installationMethods = ''
          arr.forEach((v, index) => {
            // this.
            if (index === arr.length - 1) {
              response.data.installationMethods += this.options[v]
            } else {
              response.data.installationMethods += this.options[v] + ','
            }
          })
        }
        this.form = response.data
        if (response.data.evaluateInfoResult) {
          this.evaluateInfoResult = response.data.evaluateInfoResult
        } else {
          this.evaluateInfoResult = null
        }
        this.open = true
        this.formTitle = '详情'
      })
    },
    /** 提交按钮 */
    submitForm: function () {
      console.log(this.form, '对对对对对对')

       this.$refs.form.validate((valid, object) => {
        if (valid) {
          this.submitLoading = true
          if (this.form.id !== undefined) {
            putObj(this.form)
              .then((response) => {
                this.$message.success('修改成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          } else {
            addObj1(this.form)
              .then((response) => {
                this.$message.success('新增成功', 3)
                this.open = false
                this.$emit('ok')
              })
              .finally(() => {
                this.submitLoading = false
 this.showLoading = false

              })
          }
        } else {
          return false
        }
      })
    },
  },
}
</script>
  <style lang="less" scoped>
.model_t {
  display: flex;
  align-items: center;
  margin-bottom: 10px;
  input {
    width: 30%;
    margin-right: 10px;
  }
}
img {
  width: 80px;
  height: 80px;
  margin-right: 10px;
  cursor: pointer;
}
.card-container {
  margin-top: 20px;
  // background: #f5f5f5;
  // overflow: hidden;
  // padding: 24px;
}
// /dee/.card-container > .ant-tabs-card > .ant-tabs-content {
//   height: 320px;
//   // margin-top: -16px;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-content > .ant-tabs-tabpane {
//   background: #fff;
//   padding: 16px;
// }

// .card-container > .ant-tabs-card > .ant-tabs-bar {
//   border-color: #fff;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
//   border-color: transparent;
//   background: transparent;
//   width: 500px;
//   text-align: center;
// }

// /deep/.card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
//   border-color: #fff;
//   background: #fff;
//   border-radius: 6px 6px 0 0;
//   width: 500px;
//   text-align: center;
//   font-size: 20px;
// }
// /deep/.plan_con {
//   height: 500px !important;
//   width: 500px !important;
// }
</style>
  